/**
 * @generated SignedSource<<7f2b8579568ffef8a8215760bdcf2cec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsTaskMonitoringDefault_viewer$data = {
  readonly actualPersonId: string | null;
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly defaultUseTaskOwner: boolean | null;
    readonly defaultUseTaskFollowers: boolean | null;
  } | null;
  readonly " $fragmentType": "SettingsTaskMonitoringDefault_viewer";
};
export type SettingsTaskMonitoringDefault_viewer$key = {
  readonly " $data"?: SettingsTaskMonitoringDefault_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsTaskMonitoringDefault_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsTaskMonitoringDefault_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultUseTaskOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultUseTaskFollowers",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "8ad0d169fd53b48a319e448fe4892ab4";

export default node;
